/**
 * SubtitleAndLink component
 * @returns <SubtitleAndLink />
 */

import Button from "./Button";

const SubtitleAndLink = (props) => {
    const { subtitle, btnConfig } = props;

    return (
        <div className="subtitle-and-link wrapper">
            <span className="content">
                <p>{subtitle}</p>

                <Button {...btnConfig} />
            </span>
        </div>
    )
}

export default SubtitleAndLink